module.exports = __webpack_public_path__ + "img/IMG_9000_L_BlackMatted.f3facbb1.jpg";